import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '@sondermind/configuration';

@Component({
  selector: 'intake-header',
  templateUrl: './intake-header.component.html',
  styleUrls: ['./intake-header.component.scss'],
})
export class IntakeHeaderComponent implements OnInit {
  @Input() desktopAlignment: 'left' | 'center' = 'center';
  logoLink: string | null = null;

  constructor(
    private configurationService: ConfigurationService
  ) {}

  get urlBase(): string {
    return this.configurationService.env.urlBase;
  }

  ngOnInit(): void {
    this.logoLink = this.configurationService?.env?.marketingUrl || null;
  }
}
